import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local._2bjAPUhEWRJssRyvKPqzQDm7i3QFWTd4flZl6DpPYV3WvNrwIrS2l0Kl0KjfpiTv_OuTIpUGotByYHhhuGzGSMFe1CL6nX86R7LabAeiKNIIpdV1bBQpX6-NRPj6FUZ76wMb2KMDqGA-AAx64Ab6pAq2roFpF3lMZT461Zf8naVSMqHHvvRFet5q4xydfxBfcF7D0WMOyg6fv8Xd42E9-25_yLQMNEyjsm3QJjCxe37htgoUPfBzDBV4qsOD2OUum0GslXTrOaShyVFnAFTZhjDylkNJdJa_-ilkoU7818VsKEE21rVMWaJslWY5IZA1AewqxVHyZ7n3ZYEhGHsr-S_QAz5ET9GsA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-09-04T21:17:43.444521Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local._2bjAPUhEWRJssRyvKPqzQDm7i3QFWTd4flZl6DpPYV3WvNrwIrS2l0Kl0KjfpiTv_OuTIpUGotByYHhhuGzGSMFe1CL6nX86R7LabAeiKNIIpdV1bBQpX6-NRPj6FUZ76wMb2KMDqGA-AAx64Ab6pAq2roFpF3lMZT461Zf8naVSMqHHvvRFet5q4xydfxBfcF7D0WMOyg6fv8Xd42E9-25_yLQMNEyjsm3QJjCxe37htgoUPfBzDBV4qsOD2OUum0GslXTrOaShyVFnAFTZhjDylkNJdJa_-ilkoU7818VsKEE21rVMWaJslWY5IZA1AewqxVHyZ7n3ZYEhGHsr-S_QAz5ET9GsA'

// {
//   "access_token": "v2.local.nD6D_7aRZz7KPtIWFOO0hDG1ZofhS7Msf8zjteHk2ndLh6FvgGSQSpkYraq3HQ40LKhYhB5K0SiPwruzU_6dOJOxqIhySJMuuBJ-c8lkKpDzojNKnLVlCc2v0vDlCuwY6a6hp7Jdal4FGFVFkV2fIPNoLIhA692QwqvLkwWR2Yz0jqT88wIj52o_Xp3xKWn-F6iQy9FkSkRrrMRmj1ISb-LYIJXrB-aE-QZGk5oBRAF88lHqIT-6NiK36K0CXagKgoozKsquPjO3iYjJ4_Ii_UiirmwWl7KbozFFToEb8au0Eve-1X0GzoMN7718J7Iz47Ih587XrHb-bdVU2r2IpxopvF1Q",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-09-04T21:17:43.740593Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.nD6D_7aRZz7KPtIWFOO0hDG1ZofhS7Msf8zjteHk2ndLh6FvgGSQSpkYraq3HQ40LKhYhB5K0SiPwruzU_6dOJOxqIhySJMuuBJ-c8lkKpDzojNKnLVlCc2v0vDlCuwY6a6hp7Jdal4FGFVFkV2fIPNoLIhA692QwqvLkwWR2Yz0jqT88wIj52o_Xp3xKWn-F6iQy9FkSkRrrMRmj1ISb-LYIJXrB-aE-QZGk5oBRAF88lHqIT-6NiK36K0CXagKgoozKsquPjO3iYjJ4_Ii_UiirmwWl7KbozFFToEb8au0Eve-1X0GzoMN7718J7Iz47Ih587XrHb-bdVU2r2IpxopvF1Q'

// {
//   "access_token": "v2.local.rMuYCStAKSTu0JHApHV30Sw8IustxtM1nw9pz7nyqXsinIQ0RSofx-24Lvf2bwJOtBYjGgrNagrqwvuesSsYKQjztl16noa3NMCcIenNbnrlMvf4f1E9Yb2LgL00kctV-QraND_9FS-Wrk8E4cEJwj7mrzWwYYKG3Tv6BbbTcrJvj__7gJD8vItcn2rX1et3zel2wX8YfvzulQnDmsNOaJIGY2u5ON6d46GfR-jTdmhA0oUvLi9KEs6JqR8wbZ415ddIoM8T14gwFDInTt2id5bOh0Rm7wt4GQxGVnjxQMmk2kkLyZ8_sV4Ai7gV3nCIBd9Y6aZWesPQJH1mca175nGwgtk",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-09-04T21:17:44.056287Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.rMuYCStAKSTu0JHApHV30Sw8IustxtM1nw9pz7nyqXsinIQ0RSofx-24Lvf2bwJOtBYjGgrNagrqwvuesSsYKQjztl16noa3NMCcIenNbnrlMvf4f1E9Yb2LgL00kctV-QraND_9FS-Wrk8E4cEJwj7mrzWwYYKG3Tv6BbbTcrJvj__7gJD8vItcn2rX1et3zel2wX8YfvzulQnDmsNOaJIGY2u5ON6d46GfR-jTdmhA0oUvLi9KEs6JqR8wbZ415ddIoM8T14gwFDInTt2id5bOh0Rm7wt4GQxGVnjxQMmk2kkLyZ8_sV4Ai7gV3nCIBd9Y6aZWesPQJH1mca175nGwgtk'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
